<template>
  <div :class="['pt-10 pb-5 component-div', isRTLlang(lang) ? 'rtl mrgn-rt-25' : '']">
    <b-row>
      <b-col v-if="isDisplayQuestionInfo" class="pl-14 d-flex" cols="12">
        <div :class="isFieldDisabled ? 'disable-question' : ''" class="number-sequence">
          <span v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels === undefined || activityInfo.showNumericLabels === null || componentData.sequence) && activityInfo.showNumericLabels"
                class="cursor_pointer1">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence
            }} </span>
          <span v-else-if="componentData.sequence && (activityInfo.showNumericLabels === undefined || activityInfo.showNumericLabels === null)"
                class="cursor_pointer1">{{ componentData.sequence
            }} </span>
        </div>
        <span
          v-translate:_formattedBody="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.formattedBody
          }"
          :class="['question-tital-name ml-2', isFieldDisabled ? 'disable-question' : '', isRTLlang(lang) ? 'question-heading-child' : '']"
          v-html="componentData.formattedBody"
        ></span>

        <span
          v-if="componentData && !componentData.isSkippable && !isFieldDisabled && (sendMultiChoiceData.showValidationMessage || componentData.hasFieldError)"
          v-translate:_required="{
            key: 'validation_error',
            val: lang,
            html: 'This field is required.'
          }"
          class="text-danger pl-15 fw-bold"
        >
          This field is required.
        </span>

        <span v-if="componentData.isSkippable"
              v-translate:_optional="{ key: 'label', val: lang, html: 'Optional' }"
              :class="isFieldDisabled ? 'disable-question' : ''" class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2">Optional</span>
        <span v-if="isFieldDisabled" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }"
              class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque">Skipped</span>
        <div v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon"
             class="ml-5">
          <img alt="Bell icon" data-v-c76994f4 src="@/assets/NotificaionIcon.png" />
        </div>
      </b-col>
    </b-row>
    <!-- PREVIEW MODE & EDIT MODE -->
    <template v-if="mode === 0 || mode === 1">
      <b-row v-if="componentData.hasBodyImage" class="pt-10 pl-40 pb-10">
        <b-col class="d-flex" cols="12">
          <div v-for="(img, index) in componentData.bodyImages" :key="index" class>
            <img :src="img.imageUrl" alt class="wid300" />
          </div>
        </b-col>
      </b-row>

      <SiteFacingMultiChoiceMulti v-if="isMulti"
                                  :can-score="activityInfo.canScoreResponses"
                                  :is-r-t-llang="isRTLlang(lang)"
                                  :lang="lang"
                                  :mode="mode"
                                  :question="componentData"
                                  :translation-key-initial="translationKeyInitial"
                                  :isFieldDisabled="isFieldDisabled"
                                  class="pl-40 pt-10"
                                  :trigger-validate="triggerValidate"
                                  @answerChanged="onAnswerChange"
                                  @clearAnswer="onClearAnswer"
      />

      <SiteFacingMultiChoiceSingle v-if="isSingle"
                                   :can-score="activityInfo.canScoreResponses"
                                   :is-r-t-llang="isRTLlang(lang)"
                                   :lang="lang"
                                   :mode="mode"
                                   :question="componentData"
                                   :translation-key-initial="translationKeyInitial"
                                   :isFieldDisabled="isFieldDisabled"
                                   class="pl-40 pt-10"
                                   :trigger-validate="triggerValidate"
                                   @answerChanged="onAnswerChange"
                                   @clearAnswer="onClearAnswer"
      />
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode === 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col :class="componentData.isEditedVersion ? 'col-6 previous-answer mb-12' : 'col-10'" class="pl-30">
          <span v-if="componentData.isEditedVersion" class="changed"></span>
          <SiteFacingMultiChoiceHistory :is-r-t-llang="isRTLlang(lang)" :lang="lang" :question="componentData"
                                        :translation-key-initial="translationKeyInitial" />

          <div v-if="isRTLlang(lang)" :class="[isRTLlang(lang) ? 'clearfix' : '']"></div>

          <b-row class="optionWrapper mt-12 mb-12">
            <div v-if="activityInfo.canScoreResponses" class="scoreWrapper ml-15">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12 score">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4 score">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
            </div>
          </b-row>
        </b-col>

        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer mb-12">
          <span class="previous-value-mark"></span>
          <div
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
            class="answers previous-value"
          >
            Previous value
          </div>

          <SiteFacingMultiChoiceHistory :is-comparing="true" :is-r-t-llang="isRTLlang(lang)" :lang="lang"
                                        :question="componentData" :translation-key-initial="translationKeyInitial" />

          <b-row v-if="componentData.previousOptionsIds" class="optionWrapper mt-12 mb-12">
            <div v-if="activityInfo.canScoreResponses" class="scoreWrapper ml-15">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12 score">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4 score">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import _ from "lodash";
import SiteFacingMultiChoiceMulti
  from "@/components/common/multi-choice/site-facing/site-facing-multi-choice-multi.vue";
import SiteFacingMultiChoiceSingle
  from "@/components/common/multi-choice/site-facing/site-facing-multi-choice-single.vue";
import * as MultiChoiceService from "@/components/common/multi-choice/multi-choice-service";
import SiteFacingMultiChoiceHistory
  from "@/components/common/multi-choice/site-facing/site-facing-multi-choice-history.vue";

export default {
  name: "activity-form-multi-choice-preview",

  mixins: [langTranslate],

  data() {
    return {
      noneOptionId: "",
      disableCheckBox: false
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {
      }
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    showValidationMessage: {
      type: Boolean,
      default: false
    },
    sendMultiChoiceData: {
      type: Object,
      default: () => {
      }
    },
    id: {
      type: String,
      default: ""
    },
    nextStepSequence: null,
    isClearData: {
      type: Boolean,
      default: false
    },
    lang: String
  },
  components: {
    SiteFacingMultiChoiceHistory,
    SiteFacingMultiChoiceMulti,
    SiteFacingMultiChoiceSingle
  },
  mounted() {
    if (this.mode === 1) {
      this.$emit("initAnswerChange", this.componentData);
    }
    if (this.mode === 0 || this.mode === 2) {
      if (this.componentData.isSkippable && !(this.componentData.optionsIds && this.componentData.optionsIds.length > 0)) {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode === 2) {
      if (!this.componentData.optionsIds) {
        this.componentData.optionsIds = [];
      }
      if (this.componentData.isSkippable && !(this.componentData.optionsIds && this.componentData.optionsIds.length > 0)) {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }

    this.componentData.options = this.getUniqueOptionsById(this.componentData.options, "id");
  },
  computed: {
    isMulti() {
      return MultiChoiceService.isMulti(this.componentData);
    },
    isSingle() {
      return MultiChoiceService.isSingle(this.componentData);
    }
  },
  methods: {
    isRTLlang(lang) {
      return lang == "he" || lang == "ar-IL";
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    onClearAnswer() {
      this.$emit("onClearAnswer", this.componentData);
      this.$emit("getQuestionScores");
    },
    onAnswerChange(question) {
      this.$emit("onValidateAnswer", this.sendMultiChoiceData);

      this.$nextTick(() => {
        this.$emit("onAnswerChange", question);
      });
    },
    getUniqueOptionsById(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/edit-site-partcipant-activity.scss";
@import "@/assets/multi-choice-other-answer.scss";

.component-div:hover .icons-div {
  display: block;
}

.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.ap-multiple-choice-answer {
  margin: 2px 0px 6px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;

  .ap-multichoice-option-answer {
    display: flex;
  }
}

.ap-thread-alert-message-preview {
  display: flex;
  flex-wrap: wrap;

  span p {
    margin-bottom: 0px !important;
  }
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}

.wid300 {
  max-width: 300px !important;
}

.number-sequence {
  min-width: 30px;
  display: inline-block;
}

.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}

/deep/ .custom-control-label {
  white-space: normal !important;
}
</style>
